import { findIndex } from "ramda";
import { IClientPatch, IPatchSubstAction } from ".";
import { IChooseSingleChoiceAnswerPayload } from "../../../../actions/course-author/types";
import { IChoiceExerciseItem } from "../../types";
import { createPatchBase, substPatch } from "./creators";

export const chooseSingleChoiceAnswerPatch = (
  payload: IChooseSingleChoiceAnswerPayload,
  accountId: string,
  versionId: number,
  initialPosition: string
): Array<IClientPatch<IPatchSubstAction<boolean>>> => {
  const { exercise, selectedAnswerIndex } = payload;
  const patchPosition = (index: number) => `${initialPosition}.${index}.correct`;
  const correctAnswerPatch: IClientPatch<IPatchSubstAction<boolean>> = {
    ...createPatchBase(accountId, versionId + 1),
    patch: substPatch<boolean>(false, true, patchPosition(selectedAnswerIndex)),
  };
  const {
    content: {
      items: { elems: answerItems },
    },
  } = exercise;
  const previousCorrectAnswerIndex = findIndex<IChoiceExerciseItem>(i => !i.deleted && i.correct)(answerItems);
  if (previousCorrectAnswerIndex === -1) {
    return [correctAnswerPatch];
  }
  const previousAnswerPatch: IClientPatch<IPatchSubstAction<boolean>> = {
    ...createPatchBase(accountId, versionId + 2),
    patch: substPatch<boolean>(true, false, patchPosition(previousCorrectAnswerIndex)),
  };
  return [previousAnswerPatch, correctAnswerPatch];
};
